module.exports = "/_next/static/images/logo-e2ce7480ca48ad6d3680e9bf008b835b.png";